import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import PropTypes from 'prop-types';
export var ResponsiveSizeProps = PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.array]);
var RatingRangeProps = PropTypes.oneOf([].concat(_toConsumableArray(_toConsumableArray(new Array(11)).map(function (_, i) {
  return i / 2;
})), _toConsumableArray(_toConsumableArray(new Array(11)).map(function (_, i) {
  return (i / 2).toString();
}))));
export var StarRatingProps = {
  rating: RatingRangeProps,
  ratingType: PropTypes.oneOf(['AAA', 'SELF_RATED']),
  size: ResponsiveSizeProps
};